import { BranchCategoryDetailPage } from "@/features/branch-category/pages/BranchCategoryDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-category/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchCategoryDetailPage,
});
